module.exports = __webpack_public_path__ + "static/media/googlePin11.efcb1f24.svg";